import React from "react";
import { Helmet } from "react-helmet-async";
import Link from "theme/components/atoms/Typography/Link";

const BlogList = ({ posts = [] }) => {
  return (
    <>
      <Helmet>
        <title>My Demo Blog</title>
      </Helmet>

      <Layout>
        {posts.map((post) => (
          <div key={post.title} className="hover:no-underline group space-y-3">
            <Link to={post.path} appearance="text">
              <h2
                data-demo="BlogPost / title"
                className="text-3xl mb-1 text-black group-hover:text-[#BB1F4E]"
              >
                {post.title}
              </h2>

              <time
                data-demo="BlogPost / date"
                className="text-lg text-gray-400"
                dateTime={post.date}
              >
                {new Date(post.date).toDateString()}
              </time>

              <p
                data-demo="BlogPost / description"
                className="text-xl text-justify"
              >
                {post.description}
              </p>
            </Link>
          </div>
        ))}
      </Layout>
    </>
  );
};

const Layout = ({ children }) => {
  return (
    <div className="blog-list space-y-16 py-12">
      <div className="text-center">
        <div className="mx-auto py-8">
          <img
            src="/fc-prismic.svg"
            width={256}
            alt="Front-Commerce + Prismic"
          />
        </div>
        <h1 className="text-5xl tracking-tight font-extrabold text-gray-900 sm:text-4xl">
          From the blog
        </h1>
        <p className="mt-3 max-w-xl mx-auto text-xl text-gray-400 sm:mt-4">
          Lorem ipsum dolor sit amet consectetur, adipisicing elit. Ipsa libero
          labore natus atque, ducimus sed.
        </p>
      </div>
      <div className="border-b w-full" />
      <div className="space-y-16 container max-w-2xl">{children}</div>
    </div>
  );
};

BlogList.Layout = Layout;

export default BlogList;
